module.exports = __webpack_public_path__ + "img/socialMediaLinkedinGreen.45320942.png";